import { v4 } from 'uuid';

const uuidv4 = () => v4().toString();

export default uuidv4;
